import './OutOfDateMessage.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Alert } from '../../../../../../design/alert/S_Alert';
interface IProps {
  isUpToDate: boolean;
}

export const OutOfDateMessage = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { isUpToDate } = props;

  return (
    <>
      {!isUpToDate && (
        <S_Alert
          color='warning'
          className='out-of-date-message'
        >
          {t('statisticts_dataset_unlinked')}
        </S_Alert>
      )}
    </>
  );
});
